import { ICustomerViewModel } from '../../types/interfaces'
import { contractsApi } from '../api/contractsApi'
import { customersApi } from '../api/customerApi'
import { AppDispatch } from '../store'
import { ActionType } from './actionTypes'
import { loadCustomersStatsSuccess } from './contractActions'

export function loadCustomersInProgress() {
  return { type: ActionType.LOAD_CUSTOMERS_IN_PROGRESS } as const
}

export function loadCustomersSuccess(customers: ICustomerViewModel[]) {
  return { type: ActionType.LOAD_CUSTOMERS_SUCCESS, customers } as const
}

export type CustomerAction = ReturnType<typeof loadCustomersInProgress> | ReturnType<typeof loadCustomersSuccess>

export function loadAllCustomers() {
  return (dispatch: AppDispatch) => {
    const p1 = dispatch(customersApi.endpoints.getAllCustomers.initiate()).unwrap()
    const p2 = dispatch(customersApi.endpoints.getAllUnits.initiate()).unwrap()
    const p3 = dispatch(contractsApi.endpoints.getContractStatistics.initiate({})).unwrap()
    Promise.all([p1, p2, p3]).then(([r1, r2, r3]) => {
      dispatch(loadCustomersInProgress())

      function processCustomerParents(
        customer: ICustomerViewModel,
        cd: { [id: string]: ICustomerViewModel },
        parentsArray: ICustomerViewModel[]
      ) {
        if (!!customer.parentId && !!cd[customer.parentId]) {
          const parent = cd[customer.parentId]
          parentsArray.unshift(parent)

          return processCustomerParents(parent, cd, parentsArray)
        }
      }

      const stats: { [id: string]: { [id: number]: number } } = r3

      const customersDict: { [id: string]: ICustomerViewModel } = {}
      const customersChildrenDict: { [id: string]: { [id: string]: ICustomerViewModel } } = {}

      const filteredUnitEntites = r2.filter((c) => !!c.unit)
      const filteredCustomerEntites: ICustomerViewModel[] = r1
        .filter((item) => !!item.customer)
        .map((item) => {
          const customerItem: ICustomerViewModel = {
            ...item.customer!,
            units: [],
            parents: [],
            children: [],
            totalContracts: 0,
            contracts: {},
            value: item.value!,
          }
          customersDict[item.customer!.id] = customerItem

          customersChildrenDict[item.customer!.id] = {}

          return customerItem
        })

      filteredCustomerEntites.forEach((customer) => {
        const parents: ICustomerViewModel[] = []

        if (!!customer.parentId && !!customersDict[customer.parentId]) {
          const parent = customersDict[customer.parentId]

          customersChildrenDict[parent.id][customer.id] = customer

          processCustomerParents(customer, customersDict, parents)
        }

        const c: ICustomerViewModel = {
          ...customer,
          units: [],
          parents,
          children: [],
          totalContracts: 0,
          contracts: {},
        }

        customersDict[c.id] = c
      })

      const customers = Object.values(customersDict)

      customers.forEach((c) => {
        c.children = Object.values(customersChildrenDict[c.id]).sort((a, b) => a.name.localeCompare(b.name))
      })
      filteredUnitEntites.forEach((u) => {
        const stat = stats[u.value!]
        const customer = customersDict[u.unit!.customerId]
        if (customer) {
          if (stat && customer) {
            for (const statKey in stat) {
              if (stat[statKey]) {
                if (!customer.contracts[statKey]) {
                  customer.contracts[statKey] = 0
                }
                customer.contracts[statKey] += stat[statKey]
                customer.totalContracts! += stat[statKey]
              }
            }
          }

          customer.units.push({
            ...u.unit!,
            path: u.value,
          })
        }
      })

      dispatch(loadCustomersStatsSuccess(stats))
      dispatch(loadCustomersSuccess(customers))
    })
  }
}
